import axios from '../lib/axios';

export async function getCalculators() {
  const response = await axios
    .get(`/api/v1/calculators`)
    .then((res) => res)
    .catch((error) => {
      if (error.response.status !== 409) throw error;
    });

  return response.data;
}
